import apiConfig from '../../../../../../../config/api'
import {apiRequestorHelper} from '../../../../../../../helpers'

export const getPendingDeclarationsService = ({dateValue}) => {
    return apiRequestorHelper({
        url: apiConfig.url + '/transaction/inside/getPendingDeclarations',
        method: 'post',
        body: {
            dateRange: dateValue
        }
    })
}